<ng-template #showSolicitacaoFinalizada>
    <section class="body-page aviso" [@fadeInOut]>
        <div class="card">
            <div class="card-body justify-content-center">
                <h1 class="card-title">Solicitação Finalizada!</h1>
                <br>
                <p class="text-center">
                    Ficamos feliz em ter você conosco, esperamos você <span *ngIf="listaConvidados.length > 0"> e seus
                        convidados </span>
                    no dia <b>8 de novembro de {{ dataDeHoje.getFullYear() }}</b> no <b>Restaurante Dom Antonio em
                        Curitiba
                        (PR)</b>, lembrando
                    que será no <b>Salão Romano com início as 18:30</b>.
                </p>
                <div class="col-12" style="margin-top:2rem; display:flex; align-items:center; justify-content:center;">
                    <button class="col-xl-2 btn btn-primary float-right" (click)="redirecionarParaPaginaAtual()">
                        Novo Cadastro
                    </button>
                </div>
            </div>
        </div>
    </section>
</ng-template>
<section class="container mb-4" *ngIf="solicitacaoFinalizada == false else showSolicitacaoFinalizada" [@fadeInOut]>
    <header>
        <section class="col-12 card-content">
            <h1 class="header__page__content__title">
                Formulário de inscrição do jantar de confraternização dos participantes da Fundação Copel
            </h1>
            <p class="descricao__header">
                Preencha o formulário abaixo, para confirmar sua presença e autorizar o desconto em folha, referente ao
                Jantar de Confraternização dos Participantes da Fundação Copel que será realizado no dia <b>8 de
                    novembro de {{ dataDeHoje.getFullYear() }}</b>
            </p>
            <p><b>Lembre-se de enviar o formulário uma única vez.</b></p>
        </section>
    </header>

    <body>
        <ng-template>
            <section class="col-12">
            </section>
        </ng-template>
        <section class="card-container col-12 px-2">
            <div class="card-content col-6">
                <h2>Valores</h2>
                <div>
                    <ul>
                        <li>
                            <p>Participantes e Convidados adultos - <b>R$ 118,00</b></p>
                        </li>
                        <li>
                            <p>Convidados de 6 a 10 anos - <b>R$ 59,00</b></p>
                        </li>
                        <li>
                            <p>Convidados de 1 a 5 anos - <b>CORTESIA</b></p>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="card-content col-6">
                <h2>Informações do Evento</h2>
                <div style="margin: 0.75rem 0.5rem;">
                    <p>Local: Restaurante Dom Antonio - Curitiba (PR) - Salão Romano</p>
                    <p>Horário: <b>Início às 18h30</b></p>
                </div>
            </div>
        </section>
        <section class="col-12 card-content">
            <h2>Leia com atenção!</h2>
            <blockquote>
                <ol>
                    <li>
                        <p>Não serão feitas devoluções dos valores descontados para os participantes que realizarem a
                            inscrição e não comparecerem no dia do evento. Em caso de impossibilidade de comparecimento
                            de convidados pagantes, o convite poderá ser transferido para um familiar.</p>
                    </li>
                    <li>
                        <p><b>Não serão feitas reservas de mesas!</b> Chegue cedo para garantir seu lugar com a família.
                        </p>
                    </li>
                    <li>
                        <p>A declaração das informações acima estarão sujeitas a análise e confirmação da APFC e
                            qualquer divergência acarretará em cobrança dos valores devidos.</p>
                    </li>
                    <li>
                        <p>Este formulário de inscrição é um documento com dados importantes, portanto verifique os
                            campos preenchidos no formulário.</p>
                    </li>
                </ol>
            </blockquote>
        </section>
        <section class="col-12 card-content">
            <h2>Formulário de Inscrição</h2>
            <section class="col-12 px-1">
                <h4 style="margin-top: 1rem;">Dados do Titular</h4>
                <form class="" [formGroup]="formInscricaTitular" style="padding:0.25rem 0.25rem;">
                    <div class="row">
                        <div class="col-xl-6 col-md-6 col-sm-12 mt-2 px-1">
                            <label class="label-form">Nome do Titular<span
                                    class="label__form__required">*</span></label>
                            <input class="form-control input-form" placeholder="Informe o nome Completo"
                                formControlName="nome">
                        </div>
                        <div class="col-xl-3 col-md-6 col-sm-12 mt-2 px-1">
                            <label class="label-form">Registro<span class="label__form__required">*</span></label>
                            <input class="form-control input-form" placeholder="Informe o número do Registro"
                                formControlName="registro" type="number">
                        </div>
                        <div class="col-xl-3 col-md-6 col-sm-12 mt-2 px-1">
                            <label class="label-form">CPF<span class="label__form__required">*</span></label>
                            <input class="form-control input-form" placeholder="___.___.___-__" formControlName="cpf"
                                mask="XXX.XXX.XXX-XX">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xl-3 col-md-6 col-sm-12 mt-2 px-1">
                            <label class="label-form">E-mail<span class="label__form__required">*</span></label>
                            <input class="form-control input-form" placeholder="xxxxxxx@xxxx.com"
                                formControlName="email">
                        </div>
                        <div class="col-xl-3 col-md-6 col-sm-12 mt-2 px-1">
                            <label class="label-form">Celular<span class="label__form__required">*</span></label>
                            <input class="form-control input-form" placeholder="(DDD) 9XXXX-XXXX"
                                formControlName="telefone" mask="(XX) XXXXX-XXXX">
                        </div>
                    </div>
                    <div class="col-12 mb-3" style="padding: 0px 30px;margin-top:0.5rem;">
                        <input type="checkbox" class="custom-control-input form-control" id="titularAssociado"
                            formControlName="titular" (click)="associadoFc()">
                        <label class="custom-control-label form-check-label" for="titularAssociado">
                            Declaro que sou associado titular da Associação dos Participantes da Fundação Copel -
                            (APFC), e estou com as mensalidades em dia com a associação.
                        </label>
                    </div>
                </form>
            </section>
            <section class="col-12 px-1">
                <h4 style="margin-top: 1rem;">Meus convidados (Não é necessário incluir o seu nome, somente de seus
                    convidados)</h4>
                <form class="form-body row" [formGroup]="formConvidado" (ngSubmit)="adicionarConvidado()"
                    style="padding: 0.25rem;">
                    <div class="col-xl-6 px-1 mb-3">
                        <label class="label-form">Nome completo do convidado</label>
                        <input class="form-control input-form" formControlName="nome"
                            placeholder="Informe o Nome Completo do Convidado">
                    </div>
                    <div class="col-xl-4 px-2 mb-3" *ngIf="tipoConvidado && tipoConvidado.length > 0">
                        <label class="label-form">Idade do Convidado</label>
                        <ng-select placeholder="Selecione" formControlName="tipoConvidadoId" [items]="tipoConvidado"
                            bindValue="value" bindLabel="grupo">
                        </ng-select>
                    </div>
                    <div class="col-xl-2 px-1 mb-3 content-buttons">
                        <div class="col-12 px-0">
                            <button class="btn btn-primary col-12 px-0">Adicionar</button>
                        </div>
                    </div>
                </form>
            </section>
            <ng-template #naoPossuiConvidados>
                <p class="ng-template-text" [@fadeInOut]>Você não informou nenhum convidado!</p>
            </ng-template>
            <section class="col-12 px-2" *ngIf="listaConvidados && listaConvidados.length > 0 else naoPossuiConvidados"
                [@fadeInOut]>
                <div class="col-12 convidado" *ngFor="let convidado of listaConvidados; let i = index">
                    <span>{{ convidado.nome }}</span>
                    <fa-icon class="card__header__icon lista-btn-close" size="2x" [icon]="faSquareXmark"
                        (click)="removerConvidado(i, convidado)">
                    </fa-icon>
                </div>
            </section>
        </section>
        <ng-template #naoPossuiValor>
            <div class="px-1" style="margin-top: 1rem;text-align: center;font-size: 0.875rem;margin-bottom: 0.75rem;"
                [@fadeInOut]>
                <b>O valor total foi igual a R$0,00, sendo assim não é possível escolher uma forma de pagamento! </b>
            </div>
        </ng-template>
        <section class="col-12 card-content">
            <h2>Pagamento</h2>
            <section
                *ngIf="formInscricaTitular.get('titular')?.value == false || (convidadoCrianca > 0 || convidadoAdulto > 0) else naoPossuiValor"
                [@fadeInOut]>
                <div class="col-12 px-1">
                    <ol>
                        <li>
                            <p [class.data-inativa]="!(dataDeHoje <= dataTresParcelas)">
                                <b [class.p-parcelas]="(dataDeHoje <= dataTresParcelas)">3 parcelas iguais</b>, para
                                confirmações respondidas até
                                <b>27/09/{{ dataDeHoje.getFullYear() }}</b>. Desconto em <b>out/nov/dez de {{
                                    dataDeHoje.getFullYear() }}</b>.
                            </p>
                        </li>
                        <li>
                            <p [class.data-inativa]="!(dataDeHoje <= dataDuasParcelas)">
                                <b [class.p-parcelas]="(dataDeHoje <= dataDuasParcelas)">2 parcelas iguais</b>, para
                                confirmações respondidas até
                                <b>15/10/{{ dataDeHoje.getFullYear() }}</b>. Desconto em <b>nov/dez de {{
                                    dataDeHoje.getFullYear() }}</b>.
                            </p>
                        </li>
                        <li>
                            <p><b class="p-parcelas">1 parcela</b>, para confirmações respondidas até <b>05/11/{{
                                    dataDeHoje.getFullYear() }}</b>. Desconto em <b>dez de {{ dataDeHoje.getFullYear()
                                    }}</b>.</p>
                        </li>
                    </ol>
                </div>
                <div class="col-12 px-1">
                    <h4>
                        Selecione uma opção de pagamento
                    </h4>
                    <section class="content-checkbox-parcelas">
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="flexRadioDefault" value="1"
                                id="flexRadioDefault1" [(ngModel)]="parcela">
                            <label class="form-check-label check-radio" for="flexRadioDefault1">
                                1 Parcela
                            </label>
                        </div>
                        <div class="form-check" *ngIf="dataDeHoje <= dataDuasParcelas">
                            <input class="form-check-input" type="radio" name="flexRadioDefault" value="2"
                                id="flexRadioDefault2" [(ngModel)]="parcela">
                            <label class="form-check-label check-radio" for="flexRadioDefault2">
                                2 Parcelas
                            </label>
                        </div>
                        <div class="form-check" *ngIf="dataDeHoje <= dataTresParcelas">
                            <input class="form-check-input" type="radio" name="flexRadioDefault" value="3"
                                id="flexRadioDefault3" [(ngModel)]="parcela">
                            <label class="form-check-label check-radio" for="flexRadioDefault3">
                                3 Parcelas
                            </label>
                        </div>
                    </section>
                </div>
            </section>
        </section>
        <section class="col-12 card-content">
            <h2>Resumo da Autorização do Desconto em Folha</h2>
            <section class="px-xl-1 px-lg-1 content-table">
                <table class="table table-bordered">
                    <tr class="col-12">
                        <th>Convite</th>
                        <th>Quantidade</th>
                        <th>Preço Unitario R$</th>
                        <th>Total R$</th>
                    </tr>
                    <tr>
                        <td>Associado Titular da APFC</td>
                        <td>{{getTitularValue()}}</td>
                        <td>Cortesia</td>
                        <td>Cortesia</td>
                    </tr>
                    <tr>
                        <td>Aposentado, Pensionista e Convidados acima de 11 anos</td>
                        <td>{{convidadoAdulto}}</td>
                        <td>R$ 118,00</td>
                        <td>{{ convidadoAdulto * 118 | currency:'BRL'}}</td>
                    </tr>
                    <tr>
                        <td>Convidados de 6 à 10 anos</td>
                        <td>{{convidadoCrianca}}</td>
                        <td>R$ 59,00</td>
                        <td>{{convidadoCrianca * 59 | currency:'BRL'}}</td>
                    </tr>
                    <tr>
                        <td>Convidados de 1 à 5 anos</td>
                        <td>{{convidadoBebe}}</td>
                        <td>Cortesia</td>
                        <td>Cortesia</td>
                    </tr>
                </table>
            </section>
            <div class="container-resultado">
                <h2 style="padding:0.5rem 0.75rem; background:#CFDDF6; border-radius:0.25rem; font-size:0.875rem; font-weight: 500;margin: 0.25rem;"
                    [@fadeInOut]>Valor total: {{ this.titularAssociado + (convidadoCrianca * 59) + (convidadoAdulto *
                    118) | currency:'BRL'}} </h2>
                <br />
                <h2 *ngIf="parcela > 0"
                    style="padding:0.5rem 0.75rem; background:#CFDDF6; border-radius:0.25rem; font-size:0.875rem; font-weight: 500;margin: 0.25rem;"
                    [@fadeInOut]>
                    <span *ngIf="parcela > 1" [@fadeInOut]> {{parcela}} x parcelas de {{ parcela ?
                        (this.titularAssociado + (convidadoCrianca * 59) + (convidadoAdulto * 118)) / parcela : 0 }}
                    </span>
                    <span *ngIf="parcela == 1" [@fadeInOut]> {{parcela}} x parcela de {{ parcela ?
                        (this.titularAssociado + (convidadoCrianca * 59) + (convidadoAdulto * 118)) / parcela : 0 }}
                    </span>
                </h2>
            </div>
            <div class="col-12">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="gridCheck" [(ngModel)]="aceites">
                    <label class="form-check-label" for="gridCheck">
                        Autorizo o desconto, em minha análise de pagamento, das despesas provenientes da
                        Confraternização dos Participantes da Fundação Copel.
                    </label>
                </div>
            </div>
            <div class="col-12 form-actions mb-4">
                <div class="float-right col-12 px-0">
                    <button type="submit" class="btn btn-primary col-xl-2 float-right" (click)="save()"
                        [disabled]="!aceites">
                        Enviar
                    </button>
                </div>
            </div>
        </section>
    </body>
</section>